import React from 'react'

import {Brand} from '@vio/core/src/brand/types'

import {HotelixFooter} from './HotelixFooter'

export type {FooterLinkProps} from './FooterLegalLinks'
export {FooterLink, useFooterLegalLinks} from './FooterLegalLinks'
export {FooterSocialButton} from './FooterSocialButton'

interface Props {
  /** Brand configuration. Its code determines which footer to render */
  brand: Brand
  /** Whether the brand's How to cancel link is shown, true for Israeli users */
  showHowToCancel?: boolean
}

export const CustomFooter = ({brand, showHowToCancel}: Props) => {
  if (brand.code === 'hotelix') {
    return <HotelixFooter brand={brand} showHowToCancel={showHowToCancel} />
  }
  return null
}
